var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "containerBox",
      on: { focusout: _vm.inputBlur, focusin: _vm.inputFocus }
    },
    [
      _vm.welcomeImgVisible ? _c("welcome") : _vm._e(),
      _vm._v(" "),
      _c(
        "keep-alive",
        [!_vm.$route.meta.keep ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm.$route.meta.keep ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c("take-cards-modal", { attrs: { visible: _vm.takeCardsModalVisible } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Ty93
// module chunks = 15